// Feature flag for the Event Program module. Default ON (launched).
// Build-time kill-switch: REACT_APP_EVENT_PROGRAM='false'.
// Per-browser opt-OUT:    localStorage 'event_program_enabled'='0'.
// Mirrors communications-intelligence/ciFlag.js.
export function isEventProgramEnabled() {
  try {
    const env = process.env.REACT_APP_EVENT_PROGRAM;
    if (env === 'true') return true;
    if (env === 'false') return false;                 // build-time kill-switch (unchanged)
    if (typeof window !== 'undefined' && window.localStorage) {
      // Launched: default ON; allow a per-browser opt-OUT via '0'.
      return window.localStorage.getItem('event_program_enabled') !== '0';
    }
  } catch (e) { /* ignore */ }
  return true;
}
